import { z } from 'zod'
import { email } from '~/services/api/contracts/email'
import { fileUpload } from '~/services/api/contracts/fileUpload'
import { phone } from '~/services/api/contracts/phone'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { CreateStoreRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const IMAGE = { mimes: ['jpeg', 'jpg', 'png', 'webp'], maxKb: 5120 } as const
const REQUIRED_TEXT = ['name', 'phone', 'email', 'address'] as const

// CreateStoreRequest::prepareForValidation
const normalize = fieldNormalizer({
  trimmed: REQUIRED_TEXT,
  trimmedOrNull: ['city', 'state', 'zip'],
  blankToNull: ['description'],
  website: ['website']
})

const schema = CreateStoreRequestSchema.extend({
  cover: fileUpload(IMAGE).nullish(),
  email: email(255),
  logo: fileUpload(IMAGE).nullish(),
  phone
}).strict()

export const StoreStore = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
